React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class extends React.Component
  displayName: 'BoardInviteRestrictionsComponent'

  render: t.renderable ->
    { isAdmin, hasBC, restricted } = @props

    t.div '.setting-item-detail', ->
      t.div ->
        if restricted
          t.p ->
            t.format 'only-team-members-can-be-added-to-boards-inside-this-team'
        else
          t.p ->
            t.format 'anybody-can-be-added-to-boards-inside-this-team'

      if hasBC && !isAdmin
        t.p '.helper.u-float-left', ->
          t.format 'you-need-to-be-an-admin-to-change-this-setting'



// WEBPACK FOOTER //
// ./app/scripts/views/organization/board-invite-restrictions-component.coffee